import { usePageHeader } from "contexts/PageHeaderContext";
import { useState, useEffect, useCallback } from 'react';
import { Save, HandCoins, DollarSign, Calendar, FileText, UserPlus, Shield, Trash2, Wallet } from 'lucide-react';
// import { ArrowLeft, Save, HandCoins, DollarSign, Calendar, FileText, Upload, UserPlus, Shield, Trash2, CheckCircle2, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Select, SelectContent, SelectItem, SelectValue } from '../../ui/select';
// import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { InputFieldset } from 'ui/inputFieldset';
import { SelectFieldset } from 'ui/selectFieldset';
import { SelectTriggerUI } from 'ui/selectTrigger';
import { TextareaUI } from 'ui/textareaUI';
import { createQarzanApplication, getEmployeeDetails, getQarzanListTypes } from 'services/qarzanApplicationService';
import { FullScreenLoading } from 'components/ui/loader';
import { Assignment, CreateQarzanApplicationPayload, EmployeeDetailsResponse, EmployeeInfo, GuarantorError, QarzanFormErrors, QarzanTypesApi } from 'types/qarzanHassana';
import { allowOnlyNumbers, removeSpecialCharacters, validatePhoneNumberInput } from 'utils/commonutils';
// import { getScreenDocuments } from 'services/documentService';
// import { DocumentApiResponse } from 'services/newRegistrationService';
// import { Alert, AlertDescription } from 'ui/alert';
// import { formatFileSizeFromKB } from 'utils/commonutils';


interface QarzanHasanaFormPageProps {
  onNavigate: (page: string) => void;
}


export const QarzanHasanaFormPage = ({ onNavigate }: QarzanHasanaFormPageProps) => {

  // const { user } = useAuth();
  const navigate = useNavigate();
  const { setPageHeader } = usePageHeader();
  useEffect(() => {
    setPageHeader({
      title: "Create Application",
      childTitle: "Submit interest-free loan application",
      icon: <Wallet className="h-5 w-5" />,
      onBack: () => navigate(-1),
    });
    return () => setPageHeader(null);
  }, [setPageHeader, navigate]);
  const [loading, setLoading] = useState(false);
  // PERSONAL & APPLICATION DETAILS
  const [qarzanTypes, setQarzanTypes] = useState<QarzanTypesApi[]>([])
  const [employeeInfo, setEmployeeInfo] = useState<EmployeeDetailsResponse | null>(null);
  const [employeeData, setEmployeeData] = useState<EmployeeInfo>({
    employeeId: "",
    name: "",
    itsNumber: "",
    department: "",
    salaryCurrency: "",
    CurrencyId: ""
  });
  const [applicationNo] = useState(`Auto-generated`);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [qarzanAmount, setQarzanAmount] = useState<number>(0);
  const [qarzanType, setQarzanType] = useState('');
  const [installments, setInstallments] = useState<number>(0);
  const [repaymentStartDate, setRepaymentStartDate] = useState('');
  const [againstSalary, setAgainstSalary] = useState('complete');
  const [partialAmount, setPartialAmount] = useState<number>(0);
  const [remark, setRemark] = useState('');

  // Document UPLOAD
  // const [documents, setDocuments] = useState<QarzanDocumentUpload[]>([]);

  // Rehen (Gold Security) Details
  const [hasRehen, setHasRehen] = useState(false);
  const [rehenGoldWeight, setRehenGoldWeight] = useState<number>(0);
  const [rehenGoldKarat, setRehenGoldKarat] = useState('');
  const [rehenEstimatedValue, setRehenEstimatedValue] = useState<number>(0);
  const [rehenLocation, setRehenLocation] = useState('');
  const [rehenCustodian, setRehenCustodian] = useState('');
  const [rehenCustodianContact, setRehenCustodianContact] = useState('');
  const [rehenDescription, setRehenDescription] = useState('');


  // Guarantor Details
  const [guarantors, setGuarantors] = useState([
    {
      guarantorName: '',
      guarantorItsNumber: '',
      guarantorRelation: '',
      guarantorPhone: '',
      guarantorEmail: '',
      guarantorAddress: '',
    },
  ]);

  const addGuarantor = () => {
    setGuarantors([
      ...guarantors,
      {
        guarantorName: '',
        guarantorItsNumber: '',
        guarantorRelation: '',
        guarantorPhone: '',
        guarantorEmail: '',
        guarantorAddress: '',
      },
    ]);
  };


  const removeGuarantor = (index: number): void => {
    const updatedGuarantors = guarantors.filter((_, i) => i !== index);
    setGuarantors(updatedGuarantors);
    setFormErrors((prev) => ({
      ...prev,
      guarantors:
        prev.guarantors?.filter((_, i) => i !== index) || [],
    }));
  };

  const handleGuarantorChange = (
    index: number,
    field: string,
    value: string
  ): void => {
    const updatedGuarantors = [...guarantors];

    updatedGuarantors[index] = {
      ...updatedGuarantors[index],
      [field]: value,
    };

    setGuarantors(updatedGuarantors);

    setFormErrors((prev) => ({
      ...prev,
      guarantors:
        prev.guarantors?.map((error, i) =>
          i === index
            ? {
              ...error,
              [field]: undefined,
            }
            : error
        ) || [],
    }));
  };


  const [formErrors, setFormErrors] = useState<QarzanFormErrors>({
    // date: "",
    qarzanType: "",
    qarzanAmount: "",
    installments: "",
    repaymentStartDate: "",
    againstSalary: "",
    partialAmount: "",
    rehenGoldWeight: "",
    rehenGoldKarat: "",
    rehenLocation: "",
    rehenCustodian: "",
    // document: "",
  });


  // const fetchDocuments = useCallback(async (screenName: string): Promise<QarzanDocumentUpload[]> => {
  //   const response = await getScreenDocuments(screenName);
  //   if (!response) return [];

  //   return response.map((doc: DocumentApiResponse) => ({
  //     id: String(doc.documentId),
  //     name: doc.documentName,
  //     file: null,
  //     isRequired: doc.isMandatory,
  //     acceptedFormatsList: doc?.acceptedFormatsList,
  //     // acceptedFormats: doc?.acceptedFormatsList,
  //     maxFileSizeKB: doc?.maxFileSizeKB
  //   }));
  // }, []);


  const getEmployeeInfo = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getEmployeeDetails();
      setEmployeeInfo(data);
      setEmployeeData({
        employeeId: data.employee.id || "",
        name: data.employee.fullName || "",
        itsNumber: data.employee.itsNo || "",
        department: data.assignments?.map((assignment: Assignment) => assignment.departmentName).join(", ") || "",
        salaryCurrency: data.firstSalary?.currencyHeadName || "",
        CurrencyId: data.firstSalary?.currencyHeadId || ""
      });
    } catch {
      toast.error("Failed to fetch Employee Details");
    } finally {
      setLoading(false);
    }
  }, []);


  const getQarzanTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getQarzanListTypes();
      setQarzanTypes(data)
    } catch {
      toast.error("Failed to fetch Employee Details");
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    getEmployeeInfo();
    getQarzanTypes()
    // fetchDocuments("qarzan_application").then((docs) => {
    //   setDocuments(docs);
    // });
  }, [getEmployeeInfo, getQarzanTypes]);


  // Calculate monthly installment breakdown
  const calculateInstallments = () => {
    if (!qarzanAmount || !installments || installments === 0) return [];

    const monthlyAmount = qarzanAmount / installments;
    const installmentList = [];
    let currentDate = repaymentStartDate ? new Date(repaymentStartDate) : new Date();

    for (let i = 1; i <= installments; i++) {
      const isLastInstallment = i === installments;
      let amount = monthlyAmount;

      // Adjust last installment to ensure total matches exactly
      if (isLastInstallment) {
        const totalSoFar = monthlyAmount * (installments - 1);
        amount = qarzanAmount - totalSoFar;
        // Round to nearest whole number
        amount = Math.round(amount);
      } else {
        amount = Math.round(amount);
      }

      installmentList.push({
        month: i,
        date: new Date(currentDate),
        amount: amount
      });

      // Move to next month
      currentDate = new Date(currentDate);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return installmentList;
  };


  const installmentBreakdown = calculateInstallments();


  // DOCUEMENT SECTION START
  // const validateFile = (doc: QarzanDocumentUpload, file: File): boolean => {
  //   /* ------------------ FORMAT VALIDATION ------------------ */
  //   if (doc.acceptedFormatsList?.length) {
  //     const fileExtension = file.name.split(".").pop()?.toLowerCase();

  //     const allowedFormats = doc.acceptedFormatsList.map((f: string) =>
  //       f.trim().toLowerCase()
  //     );

  //     if (!fileExtension || !allowedFormats.includes(fileExtension)) {
  //       toast.error(
  //         `Accepted format: ${allowedFormats.join(", ").toUpperCase()} only`
  //       );
  //       return false;
  //     }
  //   }
  //   /* ------------------ SIZE VALIDATION ------------------ */
  //   if (doc.maxFileSizeKB) {
  //     const maxSizeBytes = Number(doc.maxFileSizeKB) * 1024;
  //     const tolerance = 5 * 1024;

  //     if (file.size > maxSizeBytes + tolerance) {
  //       toast.error(
  //         `File size must be less than or equal to ${formatFileSizeFromKB(
  //           doc.maxFileSizeKB
  //         )}`
  //       );
  //       return false;
  //     }
  //   }

  //   return true;
  // };

  // const handleFileUpload = (docId: string, file: File | null) => {
  //   setDocuments(documents.map(doc =>
  //     doc.id === docId ? { ...doc, file } : doc
  //   ));
  // };
  // DOCUEMENT SECTION END


  const handleSubmit = async (status: "Draft" | "Posted") => {
    const errors: QarzanFormErrors = {
      // date: "",
      qarzanType: "",
      qarzanAmount: "",
      installments: "",
      repaymentStartDate: "",
      againstSalary: "",
      partialAmount: "",
      rehenGoldWeight: "",
      rehenGoldKarat: "",
      rehenLocation: "",
      rehenCustodian: "",
      guarantors: [],
      // document: ""
    };

    // if (!date) { errors.date = "Please select Date"; }
    // Qardan Type
    if (!qarzanType) { errors.qarzanType = "Please select Qardan Type"; }
    // Qardan Amount
    if (qarzanAmount <= 0) { errors.qarzanAmount = "Qardan Amount must be greater than 0"; }
    // Installments
    if (installments <= 0) { errors.installments = "Installments must be greater than 0"; }
    // Repayment Date
    if (!repaymentStartDate) { errors.repaymentStartDate = "Please select Repayment Starting Date"; }
    // Partial Salary
    if (againstSalary === "partial") {
      if (partialAmount <= 0) {
        errors.partialAmount = "Please enter valid partial repayment amount";
      } else if (
        partialAmount > qarzanAmount / installments
      ) {
        errors.partialAmount = "Partial amount cannot exceed monthly installment amount";
      }
    }
    // Rehen Validation
    if (hasRehen) {
      if (!rehenGoldWeight || rehenGoldWeight <= 0) {
        errors.rehenGoldWeight = "Please enter valid gold weight";
      }
      if (!rehenGoldKarat) {
        errors.rehenGoldKarat = "Please select gold karat";
      }
      if (!rehenLocation) {
        errors.rehenLocation = "Please specify where the gold is kept";
      }
      if (!rehenCustodian) {
        errors.rehenCustodian = "Please specify who is holding the gold";
      }
    }

    //Multiple Guarantor Validation
    const guarantorErrors: GuarantorError[] = [];

    guarantors.forEach((guarantor, index) => {
      const currentError: GuarantorError = {};
      if (!guarantor.guarantorName.trim()) {
        currentError.guarantorName =
          "Guarantor name is required";
      }
      if (!guarantor.guarantorItsNumber.trim()) {
        currentError.guarantorItsNumber =
          "ITS Number is required";
      }
      if (!guarantor.guarantorPhone.trim()) {
        currentError.guarantorPhone =
          "Phone number is required";
      }
      if (!guarantor.guarantorRelation.trim()) {
        currentError.guarantorRelation =
          "Relation is required";
      }
      guarantorErrors[index] = currentError;
    });
    errors.guarantors = guarantorErrors;


    //Set Errors
    setFormErrors(errors);

    const hasGuarantorErrors = guarantorErrors.some(
      (error) => Object.keys(error).length > 0
    );

    const hasNormalErrors = Object.values(errors).some(
      (value) => {
        if (Array.isArray(value)) {
          return value.some(
            (item) => Object.keys(item).length > 0
          );
        }
        return value !== "";
      }
    );

    //DOCUMENT CHECK
    // const missingDocs = documents.filter(doc => doc.isRequired && !doc.file);
    // if (missingDocs.length > 0) {
    //   errors.document = `Please upload all required documents`;
    // }


    if (hasNormalErrors || hasGuarantorErrors) {
      return;
    }



    try {

      // const formData = new FormData();
      const payload: CreateQarzanApplicationPayload = {
        // FIRST BLOCK START
        applicationDate: new Date(date).toISOString(),
        employeeId: Number(employeeData?.employeeId || 0),
        itsNumber: employeeData?.itsNumber || "",
        departmentIds: employeeInfo?.assignments?.map((item) => item.departmentId) || [],
        currencyId: employeeInfo?.firstSalary.currencyHeadId || employeeData?.CurrencyId || 0,
        qarzanTypeId: Number(qarzanType) || 0,
        status: status,
        // FIRST BLOCK END

        isApproved: false,
        approverId: 0,

        // SECOND BLOCK START
        qarzanAmount: Number(qarzanAmount || 0),
        installments: Number(installments || 0),
        repaymentStartingDate: new Date(repaymentStartDate).toISOString(),
        againstSalaryType: againstSalary,
        partialAmount: Number(partialAmount || 0),
        remark: remark || "",

        // REHEN GOLD THIRED BLOCK START
        providingGoldSecurity: hasRehen,
        goldSecurity: hasRehen ? {
          goldWeightGrams: Number(rehenGoldWeight || 0),
          goldKarat: Number(rehenGoldKarat) || 0,
          estimatedValue: Number(rehenEstimatedValue || 0),
          whereIsItKept: rehenLocation || "",
          withWhom: rehenCustodian || "",
          custodianContact: rehenCustodianContact || "",
          description: rehenDescription || "",
        } : undefined,

        // FOURTH BLOCK START
        hasGuarantors: true,
        guarantors: guarantors.map((item) => ({
          guarantorName: item.guarantorName || "",
          itsNumber: item.guarantorItsNumber || "",
          relationToApplicant: item.guarantorRelation || "",
          phoneNumber: item.guarantorPhone || "",
          emailAddress: item.guarantorEmail || "",
          address: item.guarantorAddress || "",
        })),

        // ✅ MAIN DOCUMENTS UPLOADS
        // documents.forEach((doc, index) => {
        //   if (!doc.file) return; // ✅ guard
        //   formData.append(`Documents[${index}].documentMasterId`, String(doc.id));
        //   formData.append(`Documents[${index}].File`, doc.file);
        //   formData.append(`Documents[${index}].FileKey`, doc.file.name);
        // })

      };

      await createQarzanApplication(payload);
      const statusText = status === "Draft" ? "saved as draft" : "posted";
      toast.success(`Application ${statusText} successfully!`);
      onNavigate("/qardan-application");
    } catch (error) {
      console.error(error);
      toast.error(
        "Failed to submit qardan application"
      );
    }
  };


  const monthlyEMI = installments > 0 ? (qarzanAmount / installments).toFixed(2) : '0.00';
  // Set default repayment start date to next month
  useEffect(() => {
    if (!repaymentStartDate) {
      const nextMonth = new Date();
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      nextMonth.setDate(1); // Start on 1st of next month
      setRepaymentStartDate(nextMonth.toISOString().split('T')[0]);
    }
  }, [repaymentStartDate]);


  return (
    <div className="space-y-6">
      {loading && <FullScreenLoading />}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Form */}
        <div className="lg:col-span-2 space-y-6">
          {/* Basic Details */}
          <Card className="bg-white/95 backdrop-blur-sm border-[#5B9BD5]/20 shadow-lg">
            <CardHeader className="border-b border-gray-100 pb-2">
              <CardTitle style={{ color: '#5B9BD5' }} className="flex items-center gap-2">
                <HandCoins className="w-5 h-5" />
                Personal & Application Details
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <InputFieldset
                    label="Application Number"
                    disabled
                    // required
                    id="applicantName"
                    // placeholder='Auto generated'
                    value={applicationNo}
                    className='cursor-not-allowed'
                  />
                </div>

                <div>
                  <InputFieldset
                    disabled
                    type='date'
                    label="Date"
                    required
                    id="date"
                    value={date}
                    onChange={(e) => {
                      setDate(e.target.value)
                    }
                    }
                    className='cursor-not-allowed'
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 cursor-not-allowed">
                <div>
                  <InputFieldset
                    label="Employee Name"
                    // required
                    disabled
                    id="code"
                    value={employeeData.name}
                    className='cursor-not-allowed'
                  />
                </div>
                <div>
                  <InputFieldset
                    label="ITS Number"
                    // required
                    disabled
                    id="itsNumber"
                    value={employeeData.itsNumber}
                    className='cursor-not-allowed'
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <InputFieldset
                    label="Department"
                    disabled
                    id="Department"
                    value={employeeData.department}
                    className='cursor-not-allowed'
                  />
                </div>
                <div>
                  <InputFieldset
                    label="Currency"
                    disabled
                    id="Currency"
                    // value={currency}
                    value={employeeData.salaryCurrency}
                    className='cursor-not-allowed'
                  />
                </div>
              </div>

              <div>
                <SelectFieldset label="Qardan Type" required>
                  <Select
                    value={qarzanType}
                    onValueChange={(value) => {
                      setQarzanType(value);
                      // Clear error on change
                      if (formErrors.qarzanType) {
                        setFormErrors({ ...formErrors, qarzanType: "" });
                      }
                    }}
                  >
                    <SelectTriggerUI className={formErrors.qarzanType ? "border-red-500" : ""}>
                      <SelectValue placeholder="Select Qardan Type" />
                    </SelectTriggerUI>
                    <SelectContent>
                      {qarzanTypes.map((type, i) => (
                        <SelectItem key={type.publicId || i} value={String(type.id)}>{type.qarzanTypeName}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </SelectFieldset>
                {formErrors.qarzanType && (
                  <p className="text-red-500 text-xs">{formErrors.qarzanType}</p>
                )}
              </div>
            </CardContent>
          </Card>

          {/* Amount & Payment Details */}
          <Card className="bg-white/95 backdrop-blur-sm border-[#5B9BD5]/20 shadow-lg">
            <CardHeader className="border-b border-gray-100 pb-2">
              <CardTitle style={{ color: '#5B9BD5' }} className="flex items-center gap-2">
                <DollarSign className="w-5 h-5" />
                Qardan Amount & Payment Details
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <InputFieldset
                    label="Qardan Amount"
                    type="text"
                    required
                    id="name"
                    value={qarzanAmount || ''}
                    min="0"
                    step="0.01"
                    onChange={(e) => {
                      const value = allowOnlyNumbers(e.target.value);
                      setQarzanAmount(parseFloat(value) || 0);
                      // Clear error on change
                      if (formErrors.qarzanAmount) {
                        setFormErrors({ ...formErrors, qarzanAmount: "" });
                      }
                    }}
                    placeholder="0.00"
                    className={formErrors.qarzanAmount ? "border-red-500" : ""}
                  />
                  {formErrors.qarzanAmount && (
                    <p className="text-red-500 text-xs">{formErrors.qarzanAmount}</p>
                  )}
                </div>
                <div>
                  <InputFieldset
                    label="Installments (Monthly) "
                    type="text"
                    required
                    value={installments || ''}
                    min="0"
                    placeholder="0"
                    onChange={(e) => {
                      const value = allowOnlyNumbers(e.target.value);
                      setInstallments(parseInt(value) || 0);
                      // Clear error on change
                      if (formErrors.installments) {
                        setFormErrors({ ...formErrors, installments: "" });
                      }
                    }}
                    className={formErrors.installments ? "border-red-500" : ""}
                  />
                  {formErrors.installments && (
                    <p className="text-red-500 text-xs">{formErrors.installments}</p>
                  )}
                </div>
              </div>

              <div>
                <InputFieldset
                  label="Repayment Starting Date"
                  type="date"
                  required
                  value={repaymentStartDate}
                  onChange={(e) => {
                    setRepaymentStartDate(e.target.value);
                    // Clear error on change
                    if (formErrors.repaymentStartDate) {
                      setFormErrors({ ...formErrors, repaymentStartDate: "" });
                    }
                  }}
                  className={formErrors.repaymentStartDate ? "border-red-500" : ""}
                />
                {formErrors.repaymentStartDate && (
                  <p className="text-red-500 text-xs">{formErrors.repaymentStartDate}</p>
                )}
                <p className="text-xs text-gray-500 mt-1">First installment will be deducted on this date</p>
              </div>

              <div>
                <SelectFieldset label="Against Salary" required>
                  <Select
                    value={againstSalary}
                    onValueChange={(value) => {
                      setAgainstSalary(value);
                      if (formErrors.againstSalary) {
                        setFormErrors({ ...formErrors, againstSalary: "" });
                      }
                      // Clear partial amount error if switching to complete
                      if (value === 'complete' && formErrors.partialAmount) {
                        setFormErrors({ ...formErrors, partialAmount: "" });
                      }
                    }}
                  >
                    <SelectTriggerUI className={formErrors.againstSalary ? "border-red-500" : ""}>
                      <SelectValue placeholder="Select Against Salary" />
                    </SelectTriggerUI>
                    <SelectContent>
                      <SelectItem value="complete">Complete - Full installment deducted from salary</SelectItem>
                      <SelectItem value="partial">Partial - Part deducted from salary</SelectItem>
                    </SelectContent>
                  </Select>
                </SelectFieldset>
                {formErrors.againstSalary && (
                  <p className="text-red-500 text-xs">{formErrors.againstSalary}</p>
                )}
              </div>

              {againstSalary === 'partial' && (
                <div>
                  <InputFieldset
                    label="Partial Amount (Per Month)"
                    type="text"
                    required
                    value={partialAmount || ''}
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    onChange={(e) => {
                      const value = allowOnlyNumbers(e.target.value);
                      setPartialAmount(parseFloat(value) || 0);
                      // Clear error on change
                      if (formErrors.partialAmount) {
                        setFormErrors({ ...formErrors, partialAmount: "" });
                      }
                    }}
                    className={formErrors.partialAmount ? "border-red-500" : ""}
                  />
                  {formErrors.partialAmount && (
                    <p className="text-red-500 text-xs">{formErrors.partialAmount}</p>
                  )}
                  <p className="text-xs text-gray-500 mt-1">
                    Amount to be deducted from salary monthly (remaining to be paid separately)
                  </p>
                </div>
              )}

              {qarzanAmount > 0 && installments > 0 && (
                <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="space-y-2">
                    <p className="text-sm text-blue-900">
                      <strong>Monthly Installment:</strong> {employeeData?.salaryCurrency} {monthlyEMI}
                    </p>
                    {againstSalary === 'partial' && partialAmount > 0 && (
                      <>
                        <p className="text-sm text-blue-900">
                          <strong>Deducted from Salary:</strong> {employeeData?.salaryCurrency} {partialAmount.toFixed(2)}
                        </p>
                        <p className="text-sm text-blue-900">
                          <strong>To be paid separately:</strong> {employeeData?.salaryCurrency} {(parseFloat(monthlyEMI) - partialAmount).toFixed(2)}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              )}

              <div>
                <SelectFieldset label="Remark">
                  <TextareaUI
                    id="Remark"
                    placeholder="Additional notes or comments"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    className="border-gray-300 min-h-[100px]"
                    rows={4}
                  />
                </SelectFieldset>
              </div>
            </CardContent>
          </Card>


          {/* Rehen (Gold Security) Details */}
          <Card className="bg-white/95 backdrop-blur-sm border-[#5B9BD5]/20 shadow-lg">
            <CardHeader className="border-b border-gray-100 pb-2">
              <div className="flex items-center justify-between">
                <CardTitle style={{ color: '#5B9BD5' }} className="flex items-center gap-2">
                  <Shield className="w-5 h-5" />
                  Rehen Details
                </CardTitle>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={hasRehen}
                    onChange={(e) => setHasRehen(e.target.checked)}
                    className="w-4 h-4 text-[#5B9BD5] border-gray-300 rounded focus:ring-[#5B9BD5]"
                  />
                  <span className="text-sm text-gray-600">Providing Gold Security</span>
                </label>
              </div>
            </CardHeader>
            {hasRehen && (
              <CardContent className="space-y-2">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <InputFieldset
                      required
                      type="number"
                      label="Gold Weight (grams)"
                      id="goldweight"
                      value={rehenGoldWeight || ''}
                      min="0"
                      step="0.01"
                      onChange={(e) => {
                        const value = allowOnlyNumbers(e.target.value);
                        setRehenGoldWeight(parseFloat(value) || 0);
                        // Clear error on change
                        if (formErrors.rehenGoldWeight) {
                          setFormErrors({ ...formErrors, rehenGoldWeight: "" });
                        }
                      }}
                      placeholder="0.00"
                      className={formErrors.rehenGoldWeight ? "border-red-500" : ""}
                    />
                    {formErrors.rehenGoldWeight && (
                      <p className="text-red-500 text-xs">{formErrors.rehenGoldWeight}</p>
                    )}
                  </div>
                  <div>
                    <SelectFieldset label="Gold Karat" required>
                      <Select
                        value={rehenGoldKarat}
                        onValueChange={(value) => {
                          setRehenGoldKarat(value);
                          if (formErrors.rehenGoldKarat) {
                            setFormErrors({ ...formErrors, rehenGoldKarat: "" });
                          }
                        }}
                      >
                        <SelectTriggerUI className={formErrors.rehenGoldKarat ? "border-red-500" : ""}>
                          <SelectValue placeholder="Select Qardan Type" />
                        </SelectTriggerUI>
                        <SelectContent>
                          <SelectItem value="24">24 Karat (99.9% pure)</SelectItem>
                          <SelectItem value="22">22 Karat (91.6% pure)</SelectItem>
                          <SelectItem value="21">21 Karat (87.5% pure)</SelectItem>
                          <SelectItem value="18">18 Karat (75% pure)</SelectItem>
                          <SelectItem value="14">14 Karat (58.3% pure)</SelectItem>
                        </SelectContent>
                      </Select>
                    </SelectFieldset>
                    {formErrors.rehenGoldKarat && (
                      <p className="text-red-500 text-xs">{formErrors.rehenGoldKarat}</p>
                    )}
                  </div>
                </div>

                <div>
                  <InputFieldset
                    type="text"
                    label={`Estimated Value (${employeeData?.salaryCurrency})`}
                    id="estimatedvalue"
                    value={rehenEstimatedValue || ''}
                    min="0"
                    step="0.01"
                    onChange={(e) => {
                      const value = allowOnlyNumbers(e.target.value);
                      setRehenEstimatedValue(parseFloat(value) || 0);
                    }}
                    placeholder="0.00"
                    className={"border-red-500"}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <InputFieldset
                      required
                      type="text"
                      label={"Where is it kept?"}
                      id="whereit"
                      value={rehenLocation || ''}
                      onChange={(e) => {
                        setRehenLocation(removeSpecialCharacters(e.target.value));
                        if (formErrors.rehenLocation) {
                          setFormErrors({ ...formErrors, rehenLocation: "" });
                        }
                      }}
                      placeholder="e.g., Office Safe, Bank Locker"
                      className={"border-red-500"}
                    />
                    {formErrors.rehenLocation && (
                      <p className="text-red-500 text-xs">{formErrors.rehenLocation}</p>
                    )}
                  </div>

                  <div>
                    <InputFieldset
                      required
                      type="text"
                      label="With Whom?"
                      id="whereit"
                      value={rehenCustodian || ''}
                      onChange={(e) => {
                        setRehenCustodian(removeSpecialCharacters(e.target.value));
                        if (formErrors.rehenCustodian) {
                          setFormErrors({ ...formErrors, rehenCustodian: "" });
                        }
                      }}
                      placeholder="e.g., HR Manager, Finance Officer"
                      className={"border-red-500"}
                    />
                    {formErrors.rehenCustodian && (
                      <p className="text-red-500 text-xs">{formErrors.rehenCustodian}</p>
                    )}
                  </div>
                </div>

                <div>
                  <InputFieldset
                    type="text"
                    label="Custodian Contact"
                    id="custodiancontact"
                    value={rehenCustodianContact || ''}
                    onChange={(e) => {
                      const value = validatePhoneNumberInput(e.target.value);
                      setRehenCustodianContact(value);
                    }}
                    placeholder="Phone number or email"
                    className={"border-red-500"}
                  />
                </div>

                <div>
                  <SelectFieldset label="Description / Additional Details">
                    <TextareaUI
                      id="rehenDescription"
                      value={rehenDescription}
                      onChange={(e) => setRehenDescription(e.target.value)}
                      placeholder="Describe the jewelry items, condition, etc."
                      className="border-gray-300 min-h-[80px]"
                      rows={4}
                    />
                  </SelectFieldset>
                </div>
              </CardContent>
            )}
          </Card>

          {/* Guarantor Details */}
          <Card className="gap-2 bg-white/95 backdrop-blur-sm border-[#5B9BD5]/20 shadow-lg">
            <CardHeader className="border-b border-gray-100 pb-2">
              <div className="flex items-center justify-between">
                <CardTitle style={{ color: '#5B9BD5' }} className="flex items-center gap-2">
                  <UserPlus className="w-5 h-5" />
                  Guarantor Details
                </CardTitle>
                <Button
                  type="button"
                  onClick={addGuarantor}
                  className="flex items-center gap-2"
                >
                  <UserPlus className="w-4 h-4" />
                  Add Guarantor
                </Button>
              </div>
            </CardHeader>
            <CardContent className="space-y-2">
              <div className="space-y-2">
                {guarantors.map((guarantor, index) => (
                  <Card key={index} className="p-4 border">
                    <div className="flex justify-between items-center">
                      <h3 className="font-semibold">
                        Guarantor {index + 1}
                      </h3>

                      {guarantors.length > 1 && (
                        <Button
                          type="button"
                          variant="destructive"
                          onClick={() => removeGuarantor(index)}
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      )}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <div>
                        <InputFieldset
                          required
                          type="text"
                          label="Guarantor Name"
                          id="guarantorName"
                          value={guarantor.guarantorName || ''}
                          onChange={(e) => {
                            const value = removeSpecialCharacters(e.target.value);
                            handleGuarantorChange(index, 'guarantorName', value)
                          }}
                          placeholder="Full name"
                          className={"border-red-500"}
                        />
                        {formErrors?.guarantors?.[index]?.guarantorName && (
                          <p className="text-red-500 text-sm mt-1">
                            {formErrors.guarantors[index].guarantorName}
                          </p>
                        )}
                      </div>

                      <div>
                        <InputFieldset
                          required
                          type="text"
                          label="ITS Number "
                          id="guarantorItsNumber"
                          value={guarantor.guarantorItsNumber || ''}
                          onChange={(e) => {
                            const value = removeSpecialCharacters(e.target.value);
                            handleGuarantorChange(index, 'guarantorItsNumber', value)
                          }}
                          placeholder="8-digit ITS number"
                          className={"border-red-500"}
                        />
                        {formErrors?.guarantors?.[index]?.guarantorItsNumber && (
                          <p className="text-red-500 text-sm mt-1">
                            {formErrors.guarantors[index].guarantorItsNumber}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <div>
                        <InputFieldset
                          required
                          type="text"
                          label="Relation to Applicant"
                          id="guarantorRelation"
                          value={guarantor.guarantorRelation || ''}
                          onChange={(e) =>
                            handleGuarantorChange(
                              index,
                              'guarantorRelation',
                              e.target.value
                            )
                          }
                          placeholder="e.g., Brother, Friend, Colleague"
                          className={"border-red-500"}
                        />
                        {formErrors?.guarantors?.[index]?.guarantorRelation && (
                          <p className="text-red-500 text-sm mt-1">
                            {formErrors.guarantors[index].guarantorRelation}
                          </p>
                        )}
                      </div>

                      <div>
                        <InputFieldset
                          required
                          type="text"
                          label=" Phone Number"
                          id="phoneNumber"
                          value={guarantor.guarantorPhone || ''}
                          onChange={(e) => {
                            const value = validatePhoneNumberInput(e.target.value);
                            handleGuarantorChange(index, 'guarantorPhone', value)
                          }}
                          placeholder="+92 300 1234567"
                          className={"border-red-500"}
                        />
                        {formErrors?.guarantors?.[index]?.guarantorPhone && (
                          <p className="text-red-500 text-sm mt-1">
                            {formErrors.guarantors[index].guarantorPhone}
                          </p>
                        )}
                      </div>
                    </div>

                    <div>
                      <InputFieldset
                        type="email"
                        label="Email Address"
                        id="guarantorEmail"
                        value={guarantor.guarantorEmail || ''}
                        onChange={(e) =>
                          handleGuarantorChange(
                            index,
                            'guarantorEmail',
                            e.target.value
                          )
                        }
                        placeholder="guarantor@example.com"
                        className={"border-red-500"}
                      />
                    </div>

                    <div>
                      <SelectFieldset label="Address">
                        <TextareaUI
                          id="Address"
                          value={guarantor.guarantorAddress || ""}
                          onChange={(e) =>
                            handleGuarantorChange(
                              index,
                              'guarantorAddress',
                              e.target.value
                            )
                          }
                          placeholder="Complete residential address"
                          className="border-gray-300 min-h-[80px]"
                          rows={4}
                        />
                      </SelectFieldset>
                    </div>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* Document Upload */}
          <Card className="hidden border-none bg-white/95 backdrop-blur-sm shadow-2xl rounded-2xl sm:rounded-3xl">
            <CardHeader>
              <CardTitle className="text-gray-900">
                Upload Supporting Documents<span className="text-destructive">*</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {/* {formErrors.document && (
                <Alert variant="destructive" className="mb-6 border-destructive/50 bg-destructive/10 border-red-400">
                  <AlertCircle className="w-4 h-4" />
                  <AlertDescription className="text-destructive text-sm">
                    {formErrors.document}
                  </AlertDescription>
                </Alert>
              )} */}

              {/* Desktop Table View */}
              <div className="hidden md:block overflow-hidden rounded-lg border border-border">
                <table className="w-full">
                  <thead>
                    <tr className="bg-blue-500 text-card">
                      <th className="px-4 py-3 text-left w-16">No.</th>
                      <th className="px-4 py-3 text-left">Document Name</th>
                      <th className="px-4 py-3 text-left">Upload File</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    {/* {documents.map((doc, index) => (
                      <tr key={doc.id} className="bg-card-table hover:bg-muted/30 transition-colors">
                        <td className="px-4 py-4">
                          <span className="flex items-center justify-center w-8 h-8 rounded-full bg-muted text-foreground">
                            {index + 1}
                          </span>
                        </td>
                        <td className="px-4 py-4">
                          <p className="text-foreground">
                            {doc.name}
                            {doc.isRequired && <span className="text-destructive ml-1">*</span>}
                          </p>
                          <p className="text-xs text-red-400">
                            {`Accepted format: ${doc.acceptedFormatsList?.join(", ") || "N/A"
                              } (Max ${formatFileSizeFromKB(doc.maxFileSizeKB)})`}
                          </p>
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex items-center gap-3">
                            <input
                              className="hidden"
                              type="file"
                              id={`file-${doc.id}`}
                              accept={
                                doc.acceptedFormatsList?.length
                                  ? doc.acceptedFormatsList
                                    .map((f: string) => "." + f.trim())
                                    .join(",")
                                  : "*"
                              }
                              onChange={(e) => {
                                const file = e.target.files?.[0] || null;
                                if (!file) return;
                                const isValid = validateFile(doc, file);
                                if (!isValid) {
                                  e.target.value = ""; // reset input
                                  return;
                                }
                                handleFileUpload(doc.id, file);
                              }}
                            />
                            <Button
                              type="button"
                              onClick={() => document.getElementById(`file-${doc.id}`)?.click()}
                              variant={doc.file ? "outline" : "default"}
                              className={doc.file ? "border-primary text-primary hover:bg-primary/10" : "bg-primary hover:bg-primary/90 text-primary-foreground"}
                              size="sm"
                            >
                              <Upload className="w-4 h-4 mr-2" />
                              {doc.file ? "Change File" : "Choose File"}
                            </Button>
                            {doc.file && (
                              <div className="flex items-center gap-1 text-xs text-green-600">
                                <CheckCircle2 className="w-4 h-4" />
                                <span className="max-w-[200px] truncate">{doc.file.name}</span>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))} */}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card View */}
              <div className="md:hidden space-y-4">
                {/* {documents.map((doc, index) => (
                  <div key={doc.id} className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-start gap-3 mb-3">
                      <span className="flex items-center justify-center w-10 h-10 rounded-full bg-muted text-foreground font-medium flex-shrink-0">
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-foreground text-sm leading-tight">
                          {doc.name}
                          {doc.isRequired && <span className="text-destructive ml-1">*</span>}
                        </p>
                        <p className="text-xs text-red-400">
                          {`Accepted format: ${doc.acceptedFormatsList?.join(", ") || "N/A"
                            } (Max ${formatFileSizeFromKB(doc.maxFileSizeKB)})`}
                        </p>
                      </div>
                    </div>

                    <div className="space-y-2">
                      <input
                        type="file"
                        id={`file-mobile-${doc.id}`}
                        accept=".pdf,.jpeg,.jpg,.gif"
                        onChange={(e) => handleFileUpload(doc.id, e.target.files?.[0] || null)}
                        className="hidden"
                      />
                      <Button
                        type="button"
                        onClick={() => document.getElementById(`file-mobile-${doc.id}`)?.click()}
                        variant={doc.file ? "outline" : "default"}
                        className={`w-full ${doc.file ? "border-primary text-primary hover:bg-primary/10" : "bg-primary hover:bg-primary/90 text-primary-foreground"}`}
                        size="sm"
                      >
                        <Upload className="w-4 h-4 mr-2" />
                        {doc.file ? "Change File" : "Choose File"}
                      </Button>

                      {doc.file && (
                        <div className="flex items-center gap-2 text-xs text-green-600 bg-green-50 p-2 rounded-lg">
                          <CheckCircle2 className="w-4 h-4 flex-shrink-0" />
                          <span className="truncate">{doc.file.name}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))} */}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Summary Sidebar */}
        <div className="lg:col-span-1">
          <div className="sticky top-6 space-y-4">
            <Card className="bg-gradient-to-br from-[#5B9BD5] to-[#4A8BC2] text-white shadow-lg">
              <CardHeader className="pb-3">
                <CardTitle className="text-white">Application Summary</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex justify-between items-center pb-3 border-b border-white/20 text-white/80">
                  <span className="">Application No</span>
                  <span className="font-mono">{applicationNo}</span>
                </div>
                <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                  <span className="">Employee</span>
                  <span className="text-right">{employeeData?.name}</span>
                </div>
                <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                  <span className="">ITS Number</span>
                  <span className="">{employeeData?.itsNumber}</span>
                </div>
                <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                  <span className="">Qardan Amount</span>
                  <span className="text-lg">{employeeData?.salaryCurrency} {qarzanAmount.toLocaleString()}</span>
                </div>
                <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                  <span className="">Installments</span>
                  <span className="text-lg">{installments}</span>
                </div>
                {qarzanAmount > 0 && installments > 0 && (
                  <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                    <span className="">Monthly EMI</span>
                    <span className="text-lg">{employeeData?.salaryCurrency} {monthlyEMI}</span>
                  </div>
                )}
                <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                  <span className="">Against Salary</span>
                  <span className="capitalize">{againstSalary}</span>
                </div>
                {againstSalary === 'partial' && partialAmount > 0 && (
                  <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                    <span className="">Salary Deduction</span>
                    <span className="">{employeeData?.salaryCurrency} {partialAmount.toFixed(2)}</span>
                  </div>
                )}
                {repaymentStartDate && (
                  <div className="text-white/80 flex justify-between items-center pb-3 border-b border-white/20">
                    <span className="">Start Date</span>
                    <span className="">
                      {new Date(repaymentStartDate).toLocaleDateString('en-GB', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                    </span>
                  </div>
                )}
                <div className="pt-2">
                  <p className="text-xs text-white/70">
                    This is an interest-free loan (Qardan Hasana) to be repaid in {installments} monthly installments.
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Installment Breakdown in Sidebar */}
            {installmentBreakdown.length > 0 && (
              <Card className="bg-white/95 backdrop-blur-sm border-[#5B9BD5]/20 shadow-lg">
                <CardHeader className="border-b border-gray-100 pb-4">
                  <CardTitle style={{ color: '#5B9BD5' }} className="flex items-center gap-2">
                    <Calendar className="w-5 h-5" />
                    Installment Breakdown
                  </CardTitle>
                </CardHeader>
                <CardContent className="">
                  <div className="space-y-3 max-h-96 overflow-y-auto">
                    {installmentBreakdown.map((installment, index) => (
                      <div
                        key={index}
                        className={`flex justify-between items-center p-3 rounded-lg border ${installment.month === installmentBreakdown.length
                          ? 'bg-green-50 border-green-200'
                          : 'bg-gray-50 border-gray-200'
                          }`}
                      >
                        <div>
                          <p className="text-sm font-medium text-gray-900">
                            Installment {installment.month}
                          </p>
                          <p className="text-xs text-gray-500">
                            {installment.date.toLocaleDateString('en-GB', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })}
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="text-lg font-bold text-gray-900">
                            {employeeData?.salaryCurrency} {installment.amount.toLocaleString()}
                          </p>
                          {installment.month === installmentBreakdown.length && (
                            <p className="text-xs text-green-600 font-medium">Final Installment</p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <div className="flex justify-between items-center">
                      <p className="font-bold text-gray-900">Total Amount:</p>
                      <p className="text-xl font-bold" style={{ color: '#5B9BD5' }}>
                        {employeeData?.salaryCurrency} {installmentBreakdown.reduce((sum, inst) => sum + inst.amount, 0).toLocaleString()}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}

            <Button
              onClick={() => handleSubmit('Posted')}
              className="w-full text-white shadow-lg hover:opacity-90 h-12"
              style={{ backgroundColor: '#5B9BD5' }}
            >
              <Save className="w-4 h-4 mr-2" />
              Post Application
            </Button>

            <Button
              onClick={() => handleSubmit('Draft')}
              variant="outline"
              className="w-full border-[#5B9BD5] text-[#5B9BD5] hover:bg-[#5B9BD5]/10 h-12"
            >
              <FileText className="w-4 h-4 mr-2" />
              Save as Draft
            </Button>


            <Button
              variant="outline"
              onClick={() => onNavigate('qardan-application')}
              className="w-full border-gray-300"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
